import type { FunctionComponent } from "react";
import { Autoplay, Navigation } from "swiper/modules";

import {
  Container,
  StyledArrowNext,
  StyledArrowPrevious,
  StyledSwiper,
  StyledSwiperSlide,
  Wrapper,
} from "./styles";
import { TestimonialItem } from "./testimonial-item";

export const Testimonial: FunctionComponent = () => {
  const feedbacks = [
    {
      comment:
        "Topical content, relevant to Hong Kong and also includes world news. My children love the cartoon strip at the end too, and the activities such as find the differences and crosswords. They also love reading the cool facts and interesting stories shared in your articles.",
      name: "Johnny Wong - Parent of 2 children",
      score: 5,
    },
    {
      comment:
        "Posties provide interesting contents, educational elements, updated news and provides global views.",
      name: "Rachel Tam - Parent of 1 child",
      score: 5,
    },
    {
      comment:
        "My daughter like to read Posties and she also shared the news from the newspaper for me. It keeps her updated with what’s going on in the world.",
      name: "Mr Cheung - Parent of 1 child", // cspell: disable-line
      score: 5,
    },
    {
      comment:
        "Content is interesting. It covers not just Hong Kong but news around the world and is very up-to-date. There are lots of fun facts shared in the Posties as well as some quizzes which are the part of fun learning.",
      name: "Arshi Ahmed - Parent of 2 children", // cspell: disable-line
      score: 5,
    },
    {
      comment:
        "My kids enjoy reading the Posties very much. It is suitable for young readers and content relates to their interests.",
      name: "Adam Berry - Parent of 2 children",
      score: 5,
    },
    {
      comment:
        "Value for money and interesting articles with different topics throughout the year. It is colourful and rich in content.",
      name: "Elsie Parker - Parent of 2 children",
      score: 5,
    },
  ];

  return (
    <Container>
      <Wrapper>
        <StyledSwiper
          autoplay={{
            delay: 8000,
          }}
          loop={true}
          modules={[Autoplay, Navigation]}
          navigation={{
            disabledClass: "swiper-button-disabled",
            nextEl: ".section-feedback__image-swiper-button-next",
            prevEl: ".section-feedback__image-swiper-button-prev",
          }}
          pagination={false}
        >
          <div className="swiper-button section-feedback__image-swiper-button-prev">
            <StyledArrowPrevious />
          </div>
          <div className="swiper-button section-feedback__image-swiper-button-next">
            <StyledArrowNext />
          </div>

          {feedbacks.map((feedback, index) => (
            <StyledSwiperSlide key={index}>
              <TestimonialItem {...feedback} />
            </StyledSwiperSlide>
          ))}
        </StyledSwiper>
      </Wrapper>
    </Container>
  );
};

Testimonial.displayName = "Testimonial";
